export default __webpack_public_path__ + "static/media/polycycle.8def2761.png";